import { ExportStatus } from './common.js';

export const Kind = 'EXPORT_PROCESSED_PAYMENTS' as const;
export { ExportStatus as Status };
